import { Divider } from '@material-ui/core';
import { FileCopyOutlined, Language, Phone } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import MarkdownWrapper from '../MarkdownWrapper';

const useStyles = makeStyles((theme) => ({
  buttonTemplate: {
    backgroundColor: "transparent",
    border: 'none',
    color: '#0CADE3',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));
// Componente para renderizar os botões dinamicamente 


const Template = ({ message }) => {
  const classes = useStyles();
  const urlRegex = /(https?:\/\/[^\s]+(\.jpg|\.jpeg|\.png|\.gif|\.mp4|\.webm|\.ogg))/g;

  // Separar a parte do texto dos botões usando '||||'
  const bodyParts = message.body ? message.body.split('||||') : [];
  const text = bodyParts[0] || message.body || '';
  const buttonsJson = bodyParts[1] || '[]';

  console.log('[Template] Body completo:', message.body);
  console.log('[Template] Texto extraído:', text);
  console.log('[Template] Botões JSON extraído:', buttonsJson);
  console.log('[Template] message.mediaUrl:', message.mediaUrl);

  // Encontra a URL de mídia no texto (se existir)
  const mediaUrls = text.match(urlRegex);
  let mediaUrl = mediaUrls ? mediaUrls[0] : null; // Considerando a primeira URL encontrada

  // ✅ NOVO: Se não encontrou URL no texto, verificar message.mediaUrl
  // O mediaUrl pode ser um caminho relativo (ex: "templates/file.jpg") ou URL completa
  if (!mediaUrl && message.mediaUrl) {
    // Construir URL completa se for caminho relativo
    if (message.mediaUrl.startsWith('http')) {
      mediaUrl = message.mediaUrl;
    } else {
      // Construir URL do backend - message.mediaUrl pode ser só o filename ou caminho relativo
      const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
      // Tentar obter companyId da mensagem, ticket ou fallback
      const companyId = message.companyId || message.ticket?.companyId || localStorage.getItem('companyId');
      const companyPath = companyId ? `company${companyId}` : '';
      
      if (companyPath) {
        mediaUrl = `${backendUrl}/public/${companyPath}/${message.mediaUrl}`;
      } else {
        console.warn('[Template] Não foi possível determinar companyId para mediaUrl');
      }
    }
    console.log('[Template] Usando mediaUrl da mensagem:', mediaUrl);
  }

  // Remove a URL de mídia do texto para não duplicar
  const textWithoutMediaUrl = text.replace(urlRegex, '').trim();

  // Funções para verificar se é uma imagem ou vídeo
  const isImage = (url) => /\.(jpeg|jpg|gif|png)$/i.test(url);
  const isVideo = (url) => /\.(mp4|webm|ogg)$/i.test(url);

  const ButtonRenderer = ({ buttons }) => {
    if (!buttons || buttons.length === 0) {
      return null;
    }
    
    // ✅ MELHORADO: Layout horizontal similar ao WhatsApp mobile
    return (
      <div style={{ 
        marginTop: '8px', 
        padding: '4px 0',
        display: 'flex', 
        flexDirection: 'row', 
        flexWrap: 'wrap',
        gap: '6px',
        alignItems: 'stretch'
      }}>
        {buttons.map((button, index) => {
          if (!button) return null;
          
          // Suporte para QUICK_REPLY (botões de resposta rápida) - estilo WhatsApp mobile
          if (button.type === 'QUICK_REPLY' || button.type === 'reply') {
            // Alternar estilo entre botões (primeiro mais escuro, segundo mais claro)
            const isFirst = index === 0;
            const buttonStyle = {
              backgroundColor: isFirst ? '#E4E6EB' : '#F0F2F5', // Cinza claro/mais claro
              color: isFirst ? '#667781' : '#008069', // Cinza escuro ou verde WhatsApp
              border: 'none', 
              borderRadius: '8px', 
              padding: '8px 12px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '400',
              flex: '1 1 auto',
              minWidth: '120px',
              textAlign: 'center',
              transition: 'all 0.2s ease',
              boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            };
            
            return (
              <button 
                key={index} 
                className={classes.buttonTemplate}
                style={buttonStyle}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = isFirst ? '#D1D3D6' : '#E4E6EB';
                  e.target.style.transform = 'scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = isFirst ? '#E4E6EB' : '#F0F2F5';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                {button.text || button.title}
              </button>
            );
          } else if (button.type === 'URL') {
            return (
              <button 
                key={index} 
                onClick={() => window.open(button.url, '_blank')} 
                className={classes.buttonTemplate}
                style={{
                  backgroundColor: '#E4E6EB',
                  color: '#008069',
                  border: 'none', 
                  borderRadius: '8px', 
                  padding: '8px 12px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: '400',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  flex: '1 1 auto',
                  minWidth: '120px',
                  justifyContent: 'center'
                }}
              >
                <Language style={{ fontSize: '16px' }} /> {button.text}
              </button>
            );
          } else if (button.type === 'PHONE_NUMBER') {
            return (
              <button 
                className={classes.buttonTemplate} 
                key={index} 
                onClick={() => window.open(`https://wa.me/${button.phone_number}`, '_blank')}
                style={{
                  backgroundColor: '#E4E6EB',
                  color: '#008069',
                  border: 'none', 
                  borderRadius: '8px', 
                  padding: '8px 12px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: '400',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  flex: '1 1 auto',
                  minWidth: '120px',
                  justifyContent: 'center'
                }}
              >
                <Phone style={{ fontSize: '16px' }} /> {button.text}
              </button>
            );
          } else if (button.type === 'COPY_CODE') {
            return (
              <button 
                key={index} 
                onClick={() => navigator.clipboard.writeText(button.example[0])} 
                className={classes.buttonTemplate}
                style={{
                  backgroundColor: '#E4E6EB',
                  color: '#008069',
                  border: 'none', 
                  borderRadius: '8px', 
                  padding: '8px 12px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: '400',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  flex: '1 1 auto',
                  minWidth: '120px',
                  justifyContent: 'center'
                }}
              >
                <FileCopyOutlined style={{ fontSize: '16px' }} /> {button.text}
              </button>
            );
          }
          return null;
        })}
      </div>
    );
  };
  
  // Parse dos botões - tentar diferentes formatos
  let buttons = [];
  if (buttonsJson && buttonsJson !== "[]" && buttonsJson.trim() !== '') {
    try {
      // Tentar parse direto primeiro
      let parsed = typeof buttonsJson === 'string' ? JSON.parse(buttonsJson) : buttonsJson;
      
      // Se for array, usar diretamente
      if (Array.isArray(parsed)) {
        buttons = parsed;
      } 
      // Se for string novamente (duplamente stringificado), fazer parse novamente
      else if (typeof parsed === 'string') {
        buttons = JSON.parse(parsed);
      }
      // Se for objeto, converter para array
      else if (typeof parsed === 'object') {
        buttons = Object.values(parsed);
      }
      
      console.log('[Template] Botões parseados:', buttons);
    } catch (e) {
      console.error('[Template] Erro ao fazer parse dos botões:', e);
      console.error('[Template] buttonsJson que causou erro:', buttonsJson);
    }
  }

  return (
    <>
      {/* Renderiza a mídia se houver uma URL de imagem ou vídeo */}
      {mediaUrl && (
        <>
          {isImage(mediaUrl) ? (
            <img src={mediaUrl} alt="media content" style={{ maxWidth: '100%', height: 'auto' }} />
          ) : isVideo(mediaUrl) ? (
            <video src={mediaUrl} controls style={{ maxWidth: '100%', height: 'auto' }} />
          ) : (
            <p>Unsupported media type</p>
          )}
        </>
      )}
      <div>

        {/* Renderiza o texto principal */}
        <MarkdownWrapper>{textWithoutMediaUrl}</MarkdownWrapper>

        {/* Renderiza os botões se houver */}
        {buttons.length > 0 && (
          <ButtonRenderer buttons={buttons} />
        )}
      </div>
    </>
  );
};

export default Template;
